import React, { PureComponent, Fragment } from 'react';
import MapBox from '../../shared/mapbox/index';
import { connect } from 'react-redux';
import _filter from 'lodash/filter';


class Details extends PureComponent {

  constructor(){
    super();
    this.onAddCity = this.onAddCity.bind(this);
  }

  onAddCity(){
    this.props.openEdit();
  }

  sectorWithCoordinates(props){
    for(var j = 0; j < props.sectors.length; j++){
      props.sectors[j].long = _filter(props.cities, ['ctfl_id', props.sectors[j].city_ctfl_id])[0].long;
      props.sectors[j].lat = _filter(props.cities, ['ctfl_id', props.sectors[j].city_ctfl_id])[0].lat;
    }
    return props.sectors;
  }

  render(){

    const { itineraries, itineraries:{sectors, total_paid, content:{nr_days, description, plus_trips }} } = this.props;
    const _sectorWithCoordinates = this.sectorWithCoordinates(itineraries);

    return (
      <div className="cyao-details" id="cyao-details">

        <div className="row">
          <div className="column small-12 large-11 large-offset-0-5">
            <div className="row">
              <div className="column small-12 medium-6 large-6">
                <div className="cyao-details-image" onClick={ () => this.props.openItineraryModal('map') }>
                  <MapBox countriesShow={_sectorWithCoordinates} clickable={false} id={'detailsview'} />
                </div>
              </div>
              <div className="column small-12 medium-6 large-5">
                <div className="cyao-details-content">
                  <h3 className="busabout-h3 uppercase">{sectors[0].city} to {sectors[sectors.length - 1].city} <span style={{fontSize:'21px'}}>({ nr_days + 1 } days)</span>
                    <small className={`blue-text ${ plus_trips !== null ? '' : 'hide' }`}><br/>
                    <svg width="20" height="20" viewBox="0 0 1792 1792" xmlns="http://www.w3.org/2000/svg"><path fill="#3ABCCB" d="M1600 736v192q0 40-28 68t-68 28h-416v416q0 40-28 68t-68 28h-192q-40 0-68-28t-28-68v-416h-416q-40 0-68-28t-28-68v-192q0-40 28-68t68-28h416v-416q0-40 28-68t68-28h192q40 0 68 28t28 68v416h416q40 0 68 28t28 68z"/></svg>{' '}
                     {plus_trips !== null ? plus_trips.toString() : ""}
                   </small>
                  </h3>
                  <ul className="cities-list">
                    {
                      sectors.map((city, i) => {
                        return (
                          <Fragment key={i}>
                            <li>{city.name}</li>
                            <span className="orange-text" style={{display: (total_paid !== "0.00" && i === sectors.length - 1) ? 'none' : 'inline' }}>&rarr;</span>
                          </Fragment>
                        )
                      })
                    }
                    <li className="add-city" onClick={this.onAddCity} style={{display:total_paid !== "0.00" ? 'none' : 'inline' }}>
                      Add City
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm144 276c0 6.6-5.4 12-12 12h-92v92c0 6.6-5.4 12-12 12h-56c-6.6 0-12-5.4-12-12v-92h-92c-6.6 0-12-5.4-12-12v-56c0-6.6 5.4-12 12-12h92v-92c0-6.6 5.4-12 12-12h56c6.6 0 12 5.4 12 12v92h92c6.6 0 12 5.4 12 12v56z"/></svg>
                    </li>
                  </ul>

                  <p className="description">
                    { description }
                  </p>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}


function mapStateToProps(state){
  return {
    itineraries:state.itineraries.data
  }
}

export default connect(mapStateToProps, null)(Details);



// WEBPACK FOOTER //
// ./src/components/itinerary/components/details.js